import {ISrpQueryParams} from '../redux/types';
import {isDefined} from '../../../../types/type-guards';
import {defaultPartner, defaultRoomString} from '../../../config/app-config';
import transformToVoyagerObject from '../../../utils/transformToVoyagerObject';

import {
  defaultCheckinOffset,
  defaultCheckoutOffset,
  parseUrlDateString,
  addDays,
} from '../../../utils/date-utils';
import {getUrlParams} from '../../../utils/common-utils';
import {ICheckinCheckoutDate} from '../../common/redux/types';
import {convertRoomStringFormat} from '../../../utils/room-string-utils';

export function parseMetaUrlToConfig(url: string, params: ISrpQueryParams & {hotelId: string}) {
  const {
    partner = defaultPartner,
    cityName,
    cityId,
    hquery = '',
    metaPartner = '',
    hotelId = '',
  } = params;

  let defaultCheckinDate = addDays(new Date(), defaultCheckinOffset);
  let defaultCheckoutDate = addDays(new Date(), defaultCheckoutOffset);

  let checkin: ICheckinCheckoutDate = {date: defaultCheckinDate};
  let checkout: ICheckinCheckoutDate = {date: defaultCheckoutDate};

  let roomString: string = defaultRoomString;
  let ibp: string = '';
  let filterStateForStore = {};
  const overriderankvhids = hotelId;

  // if (isDefined(hquery) && hquery.length > 0) {
  //   try {
  //     const {ci = '', co = '', r = defaultRoomString} = JSON.parse(decodeURIComponent(hquery));
  //     checkin.date = (ci && parseUrlDateString(ci)) || checkin.date;
  //     checkout.date = (co && parseUrlDateString(co)) || checkout.date;
  //     roomString = r;
  //   } catch (err) {
  //     // ! must add some handling to continue flow even after error here
  //     console.error(err);
  //   }
  // }

  if (isDefined(hquery) && hquery.length > 0) {
    try {
      const {ci = '', co = '', r = defaultRoomString, ibp: ibpFromMeta = ''} = JSON.parse(
        decodeURIComponent(hquery),
      );
      checkin.date = (ci && parseUrlDateString(ci)) || checkin.date;
      checkout.date = (co && parseUrlDateString(co)) || checkout.date;
      roomString = convertRoomStringFormat(r);
      ibp = ibpFromMeta;
    } catch (err) {
      console.error(err);
    }
  }

  if (url && url.length > 1) {
    try {
      const urlParamObj = getUrlParams(url);
      const filterParams = Object.keys(urlParamObj).filter(key => key.indexOf('filter') > -1);
      const locFilterParams = Object.keys(urlParamObj).filter(key => key.indexOf('ls') > -1);
      if (filterParams.length) {
        const parsedFilterObj = JSON.parse(decodeURIComponent(filterParams[0]));
        const filter = parsedFilterObj.filter;
        if (filter.hasOwnProperty('hr')) {
          filter.star = filter.hr;
          delete filter.hr;
        }
        if (filter.hasOwnProperty('l')) {
          filter.locations = filter.l;
          delete filter.l;
        }
        if (filter.hasOwnProperty('hti')) {
          filter.type = filter.hti;
          delete filter.hti;
        }
        if (filter.hasOwnProperty('tgi')) {
          filter.tags = filter.tgi;
          delete filter.tgi;
        }
        // if (filter.stmg) {
        //   hotels.slotSelected = true;
        // }
        filterStateForStore = {filter: {...filter}};
      }
      if (locFilterParams.length) {
        // ! need more typing around here
        const results = JSON.parse(decodeURIComponent(locFilterParams[0]));
        if (
          results &&
          results.ls &&
          results.ls.loc &&
          results.ls.loc.crd &&
          results.ls.loc.crd.length
        ) {
          const loc = results.ls;
          const {crd = []} = loc;
          filterStateForStore = {
            ...filterStateForStore,
            la: crd[0],
            lo: crd[1],
            s: 'nearby',
          };
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  return {
    partner,
    destination: transformToVoyagerObject(
      (isDefined(cityName) && decodeURIComponent(cityName)) || '',
      cityId,
    ),
    checkin,
    checkout,
    roomString,
    metaPartner,
    ibp,
    overriderankvhids,
    filter: {...filterStateForStore},
  };
}
